import React from 'react'
import FooterThree from './FooterThree'

const FooterOne = () => {
    return <FooterThree />
}

export default FooterOne
